import { useState } from "react";
import { Menu, MenuItem, SvgIcon } from "@mui/material";
import FormatListBulletedOutlinedIcon from "@mui/icons-material/FormatListBulletedOutlined";

import { Tooltip, Checkbox } from "../../../../components";
import IconButton from "../../../../components/IconButton";

import { TSortableColumn } from ".";

interface IFilterButtonProps<T> {
  columns: TSortableColumn<T>[];
  onChange: (col: TSortableColumn<T>) => void;
}

export const FilterButton = <T,>({
  columns,
  onChange,
}: IFilterButtonProps<T>) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const isOpen = Boolean(anchorEl);
  const buttonId = `filter-button-${columns
    .map((col) => col.header)
    .join("-")}`;
  const menuId = `filter-menu-${columns.map((col) => col.header).join("-")}`;

  return (
    <>
      <IconButton
        id={buttonId}
        aria-controls={isOpen ? menuId : undefined}
        aria-haspopup="true"
        aria-expanded={isOpen ? "true" : undefined}
        onClick={(event: React.MouseEvent<HTMLButtonElement>) =>
          setAnchorEl(event.currentTarget)
        }
        title="Columns"
        size="large"
      >
        <Tooltip title={"Columns"}>
          <SvgIcon
            component={FormatListBulletedOutlinedIcon}
            sx={{ fontSize: "18px" }}
          />
        </Tooltip>
      </IconButton>
      <Menu
        id={menuId}
        anchorEl={anchorEl}
        open={isOpen}
        onClose={() => setAnchorEl(null)}
        slotProps={{
          list: { "aria-labelledby": buttonId },
        }}
      >
        {columns.map((col: TSortableColumn<T>) => {
          return (
            <MenuItem
              key={`menu-item-${col.header}`}
              onClick={(e) => {
                e.preventDefault();
                onChange(col);
              }}
              sx={{ height: "30px", padding: "0 8px" }}
            >
              <Checkbox label={col.header} checked={!col.hidden} />
            </MenuItem>
          );
        })}
      </Menu>
    </>
  );
};

export default FilterButton;
